import React from 'react';
import { Button, Modal } from "react-bootstrap";
import DownloadButton from "../../buttons/DownloadButton";
import { DEFAULT_FILE_NAME } from "../../constants";
import FontAwesome from "react-fontawesome";

const ModalComponent = ({
  modalShowState,
  setModalShowState,
  setExerciseNameState,
  exportState
}) => /*#__PURE__*/React.createElement(Modal, {
  dialogClassName: "no-border-radius",
  show: modalShowState,
  onHide: () => setModalShowState(false)
}, /*#__PURE__*/React.createElement(Modal.Header, null, /*#__PURE__*/React.createElement(Modal.Title, null, "Export exercise")), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement("div", {
  className: "form-inline"
}, /*#__PURE__*/React.createElement("div", {
  className: "form-group"
}, /*#__PURE__*/React.createElement("label", {
  htmlFor: "exercise-name"
}, "Exercise name: "), /*#__PURE__*/React.createElement("input", {
  type: "text",
  className: "form-control",
  id: "exercise-name",
  placeholder: DEFAULT_FILE_NAME,
  onChange: e => setExerciseNameState(e.target.value)
})))), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(DownloadButton, {
  genFile: exportState,
  title: "Save",
  className: "btn btn-success"
}), /*#__PURE__*/React.createElement(Button, {
  variant: "secondary",
  title: "Cancel",
  onClick: () => setModalShowState(false)
}, /*#__PURE__*/React.createElement(FontAwesome, {
  name: "fas fa-window-close"
}), "\xA0Cancel")));

export default ModalComponent;